// SEO Configuration
// Base URL sa www - OVO JE GLAVNA VERZIJA
export const BASE_URL = "https://www.predsense.ai";

// Helper funkcija za generisanje canonical URL-a
export const getCanonicalUrl = (path = "") => {
  // Ukloni početni slash ako postoji, pa dodaj ga ponovo
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${BASE_URL}${cleanPath}`;
};

